import './styles/App.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import gif from './gif/hello.gif';
import AppRoutes from './components/AppRoutes';
import LanguageSwitcher from './components/LanguageSwitcher';
import useTranslation from './hooks/useTranslation';

function App() {
  const [showWelcome, setShowWelcome] = useState(true);
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      setShowWelcome(false);
    }
  }, [location]);

  return (
      <div className="App">
        <header className="App-header">
          <NavLink to="/Dictionary" className="App-link" activeClassName="active">{t('navigation.dictionary')}</NavLink>
          <NavLink to="/Tasks" className="App-link" activeClassName="active">{t('navigation.tasks')}</NavLink>
          <div>
            <LanguageSwitcher/>
          </div>
        </header>
        <AppRoutes />
        {showWelcome && location.pathname === "/" && (
           <div>
            <div className='welcome'>
              <p className='welcome-head'>{t('helloPage.welcomeHead')}</p>
              <img src={gif} alt="Celebration GIF" className="gif" />
              <span className='welcome-text'>{t('helloPage.welcomeText1')}</span>
              <p className='welcome-text'>{t('helloPage.welcomeText2')}</p>
            </div>
            <div  className='thank-note'>
              <p className='thank-text'>{t('helloPage.thankNoteHead')}</p>
              <p className='thank-text'>{t('helloPage.thankNote')}</p>
            </div>
          </div>
        )}
      </div>
  );
}

export default App;
